<template>
  <div>
    <!-- Update Email Form -->
    <div v-if="!updateSuccess">
      <!-- Company Logo -->
      <company-logo />

      <!-- Title -->
      <list-header title="Update Email" />

      <!-- Update Email Form -->
      <div class="p-3 text-start">
        <div class="mb-3">You may update your email to receive OTP.</div>
        <Form @submit="handleResetEmail" :validation-schema="schema">
          <div>
            <Field
              name="email"
              :value="email"
              v-slot="{ handleChange, errorMessage }"
            >
              <default-input-field
                type="text"
                placeholder="Enter your new email"
                v-model:value.trim="email"
                @update:value="handleChange"
                :errorValidate="errorMessage"
              />
            </Field>
          </div>

          <div class="mt-3">
            <Field name="confirmEmail" v-slot="{ handleChange, errorMessage }">
              <default-input-field
                type="text"
                placeholder="Confirm your new email"
                v-model:value="confirmEmail"
                @update:value="handleChange"
                :errorValidate="errorMessage"
              />
            </Field>
          </div>

          <!-- Reset Passowrd Button -->
          <div class="scss-button-position-bottom">
            <default-button title="Update Email" type="submit" />
          </div>
        </Form>
      </div>
    </div>

    <!-- Booking Done Message -->
    <div v-if="updateSuccess">
      <back-button
        goBackTo="/signup/update-email"
        @click="() => (updateSuccess = false)"
      />
      <!-- Company Logo -->
      <company-logo />

      <!-- Title -->
      <list-header title="Request OTP" />

      <div class="p-3 text-start">
        <div>We will be sending the OTP to the following email.</div>
        <div class="my-4 scss-bold">
          <div class="d-flex flex-row">
            <div class="w-25 text-start ms-5">Email</div>
            <div class="w-50 text-start ms-5 text-truncate">
              {{ duplicateCustomerTemporary.customerDetail.email }}
            </div>
          </div>
        </div>
      </div>

      <!-- Homepage Button -->
      <div class="scss-button-position-bottom">
        <default-button title="Request OTP" @click="goToOtp" />
      </div>
    </div>
  </div>
</template>

<script>
import { Form, Field } from "vee-validate";
import { mapGetters } from "vuex";
import * as yup from "yup";
import { useToast } from "vue-toastification";

import DefaultInputField from "@/components/input/DefaultInputField.vue";
import DefaultButton from "@/components/button/DefaultButton.vue";
import CompanyLogo from "@/components/CompanyLogo.vue";
import BackButton from "@/components/button/BackButton.vue";
import ListHeader from "@/components/ListHeader.vue";
import { validationRules } from "@/validation/ValidationRules";
import { updateEmail } from "@/services/auth";

export default {
  name: "UpdateEmail",
  components: {
    DefaultInputField,
    Form,
    Field,
    ListHeader,
    DefaultButton,
    CompanyLogo,
    BackButton,
  },
  data() {
    return {
      email: null,
      confirmEmail: null,
      updateSuccess: false,
    };
  },
  computed: {
    schema() {
      return yup.object({
        email: validationRules.email,
        confirmEmail: validationRules.confirmEmail,
      });
    },
    ...mapGetters(["duplicateCustomerTemporary"]),
  },
  methods: {
    async handleResetEmail() {
      try {
        await updateEmail(this.duplicateCustomerTemporary.id, this.email).then(
          (res) => {
            this.$store.commit("updateDuplicateCustomerTemporary", res.data);
            useToast().success("Your email has been update successfully.");
          }
        );
        this.updateSuccess = true;
      } catch (error) {
        useToast().error("Unable to update your email.");
      }
    },
    goToOtp() {
      this.$router.push("/signup/otp");
    },
  },
};
</script>
